import { FilterTransactionForm } from 'core/movimientos/components/FilterTransactionForm/FilterTransactionForm';
import { TransactionTableWithPagination } from 'core/movimientos/components/TransactionTableWithPagination/TransactionTableWithPagination';
import { TransactionListContext } from 'core/movimientos/contexts/TransactionListContext';
import { useContext } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Card } from 'shared/components';
import { PageTitle } from 'shared/components/Fonts';

export const TransactionListPage = () => {
  const { searchParams, reloadToken } = useContext(TransactionListContext);
  return (
    <Container fluid>
      <Row className="mb-3">
        <PageTitle>Historial de Movimientos</PageTitle>
      </Row>
      <Row className="mb-4">
        <Col>
          <Card>
            <Card.Title>Filtros</Card.Title>
            <Card.Body>
              <FilterTransactionForm />
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card>
            <Card.Title>Movimientos</Card.Title>
            <Card.Body>
              <TransactionTableWithPagination
                searchParams={searchParams}
                reloadToken={reloadToken}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
